import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, Button, Textarea, IconWarning, IconTick} from '../../index';

import css from './FeeCancellationModal.css';

const FeeCancellationModal = props => {
  const {
    className,
    rootClassName,
    id,
    isOpen,
    onCloseModal,
    transaction,
    deleteServiceFeeInProgress = false,
    deleteServiceFeeError = false,
    deleteServiceFeeSuccess = false,
    onDeleteServiceFee,
    onClear,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
    const intl = useIntl();
    const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
     e.preventDefault()
    onDeleteServiceFee({id: transaction.id, reason });
  };

  const handleClose = () => {
    onClear();
    onCloseModal();
  };

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={handleClose}
      usePortal
      closeButtonMessage={' '}
      onManageDisableScrolling={()=>{}}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="FeeCancellationModal.title" />
      </p>
       {deleteServiceFeeSuccess ? (
        <p className={css.success}>
          <IconTick className={css.iconTick} />
          <FormattedMessage id="FeeCancellationModal.success" />
        </p>
      ) : (
      <div className={css.mainForm}>
        {deleteServiceFeeError ? (
          <p className={css.error}>
            <IconWarning variant="error" /> <FormattedMessage id='ServiceFeeModal.error' />
          </p>
        ) : null}

        <Textarea
          label={intl.formatMessage({ id: 'FeeCancellationModal.label' })}
          placeholder={intl.formatMessage({ id: 'FeeCancellationModal.placeholder' })}
          id='reason'
          value={reason}
          onChange={event => setReason(event.target.value)}
          onWheel={e => e.target.blur()}
          markRequired={true}
          containerClassName={css.textareContainer}
        />
        <Button inProgress={deleteServiceFeeInProgress} type="submit" disabled={reason.length < 3} onClick={e => handleSubmit(e)}>
          {intl.formatMessage({ id: 'TransactionPanel.cancelServiceFee' })}
        </Button>
      </div>
      )}
    </Modal>
  );
};

export default FeeCancellationModal;
